import React, { useEffect } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';
import CheckIcon from '~/../symbols/check.svg';

/* Common */
import { Icon } from '~/components/common';

/* Icons */
import iDealIcon from '~/../symbols/iDeal.svg';

/* Utilities */
import { trans } from '~/utilities';

export default function ConversionFieldChoice(props) {
    const { colClassName, formGroupClassName = '', customControlClassName = '', field, inputType, path, id, updateChoice, componentName } = props;
    const { type, label, choices, required, disabled, value, name } = field;

    const form = useFormContext();
    const {
        setValue = () => { },
        trigger = () => { },
    } = form || {};

    const { error } = useValidation({ path, ...field, ...form });

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    return (
        <div className={`${colClassName}`}>
            <Form.Group controlId={id} className={`form-group--flow form-group--flow-field-${type} form-group--flow-${name} ${formGroupClassName}`}>
                {label && (
                    <Form.Label dangerouslySetInnerHTML={{ __html: label }} />
                )}
                {choices?.map((choice, choiceIndex) => {
                    return (
                        <Form.Check
                            key={choice.key}
                            className={`custom-control custom-${inputType} ${customControlClassName} ${error ? 'is-error' : ''}`}
                            type={inputType}
                            id={`${id}.choices.${choiceIndex}-${choice.key}`}
                        >
                            <Form.Check.Input
                                type={inputType}
                                className="custom-control-input"
                                name={id}
                                value={choice.key}
                                {...{
                                    required,
                                    disabled,
                                }}
                                checked={value?.includes(choice.key)}
                                onChange={(e) => {
                                    updateChoice(choice, e.target.checked, () => {
                                        trigger(path);
                                    });
                                }}
                            />
                            <Form.Check.Label className={`d-block custom-control-label ${(choice.iconType && choice.iconType === 'ideal') ? 'custom-control-label--ideal' : ''} `}>
                                <div className="d-block d-lg-flex align-items-center justify-content-between">
                                    <div className="custom-control-label__title d-flex">
                                        <span dangerouslySetInnerHTML={{ __html: (choice.iconType && choice.iconType === 'ideal') ? 'iDEAL  ' : choice.label }} />
                                    </div>
                                    <div className="d-flex align-items-center">
                                        {choice.most_chosen && (
                                            <span className="custom-control-label__badge">
                                                {trans('app.flow.most_chosen')}
                                            </span>
                                        )}
                                        {choice?.['pay-off'] && (
                                            <span className="custom-control-label__pay-off ml-0 ml-lg-1 my-1 my-lg-0 d-block text-left text-lg-right">{choice?.['pay-off']}</span>
                                        )}
                                    </div>
                                    {(choice.iconType && choice.iconType === 'ideal') && (
                                        <Icon
                                            theme="base"
                                            className={`icon icon--40 flex-shrink-0`}
                                            url={iDealIcon?.url}
                                        />
                                    )}
                                </div>
                                {(choice.tooltip && choice.tooltip !== '') && (
                                    <>
                                        {componentName === 'delivery' || componentName === 'service-or-maintenance-subscription' ? (
                                            <ul className="list list--delivery">
                                                {choice.tooltip.split(',').map((item, index) => (
                                                    <li key={index} className="list__item">
                                                        <Icon
                                                            theme="success"
                                                            size={14}
                                                            className="flex-shrink-0 mr-2"
                                                            url={CheckIcon?.url}
                                                        />
                                                        <p className="mb-0" dangerouslySetInnerHTML={{ __html: item }} />
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <span className="custom-control__info font-weight-normal" dangerouslySetInnerHTML={{ __html: choice.tooltip }} />
                                        )}
                                    </>
                                )}
                            </Form.Check.Label>
                        </Form.Check>
                    );
                })}
                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
